import { createContext, useContext, type Context } from 'react';

import type { AttachmentActionDiscoveryExperienceStatus } from './useAttachmentActionDiscoveryExperience.ts';

/** Discovery state is separate from the row context, which is null for both loading and empty results. */
export type AttachmentActionLoadState = {
	status: AttachmentActionDiscoveryExperienceStatus | 'disabled';
	hasExtensions: boolean;
};

export const DISABLED_ATTACHMENT_ACTION_LOAD_STATE: AttachmentActionLoadState = {
	status: 'disabled',
	hasExtensions: false,
};

export const AttachmentActionMetadataLoadStateContext: Context<AttachmentActionLoadState> =
	createContext(DISABLED_ATTACHMENT_ACTION_LOAD_STATE);
export const AttachmentActionEligibilityLoadStateContext: Context<AttachmentActionLoadState> =
	createContext(DISABLED_ATTACHMENT_ACTION_LOAD_STATE);

export const useAttachmentActionLoadState = (): {
	metadata: AttachmentActionLoadState;
	eligibility: AttachmentActionLoadState;
} => ({
	metadata: useContext(AttachmentActionMetadataLoadStateContext),
	eligibility: useContext(AttachmentActionEligibilityLoadStateContext),
});
